import { render, staticRenderFns } from "./TransportersForm.vue?vue&type=template&id=7185090c&scoped=true&"
import script from "./TransportersForm.vue?vue&type=script&lang=js&"
export * from "./TransportersForm.vue?vue&type=script&lang=js&"
import style0 from "./TransportersForm.vue?vue&type=style&index=0&id=7185090c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7185090c",
  null
  
)

export default component.exports